"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigClientV1 = exports.ConfigClientV2 = void 0;
var configuration_1 = require("../domains/configuration");
var abstract_resource_client_1 = require("./abstract-resource-client");
var signature_v4_rest_client_1 = require("./signature-v4-rest-client");
var ConfigClientV2 = /** @class */ (function (_super) {
    __extends(ConfigClientV2, _super);
    function ConfigClientV2(endpointName) {
        return _super.call(this, endpointName) || this;
    }
    ConfigClientV2.prototype.getConfig = function () {
        return _super.prototype.get.call(this, '/configuration').then(function (data) {
            return new configuration_1.ConfigurationV1(data);
        });
    };
    return ConfigClientV2;
}(signature_v4_rest_client_1.SignatureV4RestClient));
exports.ConfigClientV2 = ConfigClientV2;
var ConfigClientV1 = /** @class */ (function (_super) {
    __extends(ConfigClientV1, _super);
    function ConfigClientV1(endpointName, getNewTokenFn) {
        return _super.call(this, endpointName, getNewTokenFn) || this;
    }
    ConfigClientV1.prototype.getConfig = function () {
        return _super.prototype.get.call(this).then(function (data) { return new configuration_1.ConfigurationV1(data); });
    };
    return ConfigClientV1;
}(abstract_resource_client_1.AbstractConfigurationClient));
exports.ConfigClientV1 = ConfigClientV1;
//# sourceMappingURL=config-client.js.map